export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full pt-16 overflow-hidden"
      style={{ scrollMarginTop: '64px' }}
    >
      {/* background gradient accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-16">
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">

          {/* Left: Text */}
          <div className="flex-1 w-full flex flex-col gap-5">
            {/* Tag */}
            <span className="inline-flex items-center gap-1.5 self-start px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
              <i className="ri-flashlight-fill text-sm"></i>
              24小时实时追踪
            </span>

            {/* H1 */}
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              今日大瓜
              <span className="block text-primary-500">
                娱乐热点与热点大瓜追踪平台
              </span>
            </h1>

            {/* Slogan */}
            <p className="font-heading text-lg md:text-xl text-foreground-600">
              娱乐圈热点爆料，吃瓜资讯一网打尽
            </p>

            {/* Intro */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              今日大瓜聚焦娱乐热点与热点大瓜追踪，每日实时更新娱乐圈最新动态和热点爆料内容。
              无论是明星八卦、影视资讯还是综艺热点，热门吃瓜事件第一时间呈现，
              让你站在吃瓜第一线，不错过任何娱乐圈的精彩瞬间。
            </p>

            {/* Indicators */}
            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-bar-chart-2-fill text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700 whitespace-nowrap">
                  <strong className="text-foreground-900">日均200+</strong> 热点资讯
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-global-fill text-primary-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700 whitespace-nowrap">
                  <strong className="text-foreground-900">50+</strong> 娱乐资讯源
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-time-fill text-secondary-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700 whitespace-nowrap">
                  <strong className="text-foreground-900">7×24</strong> 不间断追踪
                </span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 pt-1">
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); scrollTo('features'); }}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors duration-200"
              >
                立即吃瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('ranking'); }}
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-100 transition-colors duration-200"
              >
                查看热榜
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20abstract%20visual%20representing%20entertainment%20news%20and%20celebrity%20gossip%20culture%2C%20warm%20coral%20and%20amber%20color%20tones%2C%20modern%20editorial%20style%20composition%20with%20flowing%20abstract%20shapes%2C%20subtle%20news%20headline%20and%20spotlight%20elements%2C%20sophisticated%20magazine%20cover%20aesthetic%2C%20high%20contrast%20with%20soft%20gradient%20transitions%2C%20digital%20art%20style%2C%20no%20visible%20text&width=800&height=600&seq=hero-main-01&orientation=landscape"
                alt="今日大瓜娱乐热点追踪主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}